

const MoreWithPlaybackSpeedButton = ({
    onMoreClick,
    className = '',
}) => {
    const audio = document.getElementById('audio');

    function displayPlaybackRate(value) {
        // Convert the number to a string with a maximum of 2 decimal places
        let formattedString = value.toFixed(2);

        // Remove trailing zeros after the decimal point
        formattedString = formattedString.replace(/\.?0+$/, '');

        return formattedString;
    }

    return (
        <button type='button' onClick={onMoreClick} className={className} aria-label='Playback speed'>
            <span className='previewPlaybackButtonLabel'>
                {displayPlaybackRate(audio?.playbackRate ?? 1)}×
            </span>
        </button>
    );
};

export default MoreWithPlaybackSpeedButton;
